import * as React from 'react';
import styles from './Footer.css';
import { socials, links } from '@/constants/constants';

const Footer: React.FunctionComponent = () => {
	const [showCopyMessage, setShowCopyMessage] = React.useState(false);

	const copyClick = (): void => {
		navigator.clipboard.writeText(window.location.href)
			.then(() => {
				setShowCopyMessage(true);

				setTimeout(() => {
					setShowCopyMessage(false);
				}, 2000);
			});
	};

	return (
		<div className={styles.footer}>
			<div className={styles.infoBlock}>
				<h1 className={styles.title}>Почте Mail.ru доверяют миллионы пользователей</h1>

				<div className={styles.stores}>
					<div className={styles.store}>
						<div className={styles.ratingBlock}>
							<p className={styles.point}>4,5</p>
							<div className={styles.rating}>
								<div className={styles.ratingGoogle} />
							</div>
						</div>

						<a href="https://trk.mail.ru/c/rcgnz7" target="_blank" className={styles.storeLink}>
							<img
								src="https://img.imgsmail.ru/static.promo/calls/landing/google-button.svg"
								className={styles.storeImage}
							/>
						</a>
					</div>
					<div className={styles.store}>
						<div className={styles.ratingBlock}>
							<p className={styles.point}>4,7</p>
							<div className={styles.rating}>
								<div className={styles.ratingApple} />
							</div>
						</div>

						<a href="https://trk.mail.ru/c/mfny91" target="_blank" className={styles.storeLink}>
							<img
								src="https://img.imgsmail.ru/static.promo/calls/landing/app-button.svg"
								className={styles.storeImage}
							/>
						</a>
					</div>
				</div>

				<div className={styles.socialBlock}>
					{socials.map(({ href, icon }, index) => (
						<a className={styles.social} href={href} target="_blank" key={index}>
							<img src={icon} className={styles.socialIcon} />
						</a>
					))}

					<div className={styles.social} onClick={copyClick}>
						<img
							src="https://img.imgsmail.ru/static.promo/calls/landing/copy.svg"
							className={styles.socialIcon}
						/>
					</div>
					{showCopyMessage && (
						<div className={styles.copyMessage}>Скопировано!</div>
					)}
				</div>

				<div className={styles.linksBlock}>
					{links.map(({ name, href }, index) => (
						<a href={href} target="_blank" className={styles.link} key={index}>
							<p className={styles.linkText}>{name}</p>
						</a>
					))}
				</div>
			</div>

			<div className={styles.imageBlock}>
				<img src="https://img.imgsmail.ru/static.promo/jsonld-demo/ios.png" className={styles.image} />
			</div>

			<a className={styles.logoBlock} target="_blank" href="https://mail.ru">
				<img src="https://img.imgsmail.ru/static.promo/jsonld-demo/mail.svg" />
			</a>
		</div>
	);
};

export default Footer;
